import { Injectable } from '@angular/core';
import { Criterion } from './criterion'
import { UtilsService } from './utils.service'
import { Observable }  from 'rxjs/Observable';
import { RuntimeService } from './runtime.service'
import { ProjectService } from './project.service'
import { DbRecordService } from './db-record.service'
import { CriterionItem } from './criterion-item'
import { Project } from './project'
import { DbRecord } from './db-record'

@Injectable()
export class CriterionService {
  _tempCriterionItemValues = new Map<string, string[]>();
  private _ciCounter = 1;
  currentCriterion: Criterion;

  constructor(
    private rts: RuntimeService,
    private utils: UtilsService,
    private projects: ProjectService,
    private dbrs: DbRecordService
  ) {
    this.projects.cs = this;
    this.dbrs.cs = this;
  }

  new(p: Project, params: Object) {
    let c = new Criterion(this, p, `c${this._ciCounter++}`, params['title']);
    params['items'].forEach((tpl) => this.addItem(c, tpl[0], tpl[1]));
  }

  newExternal(p: Project, title: string, weights: [string, number][]) {
    let c = new Criterion(this, p, `c${this._ciCounter++}`, title, true);
    c.setExternalWeights(weights);
  }

  addItem(c: Criterion, rg?: string, w?: (string | number)) {
    rg = rg || null;
    if (typeof w == 'string') {
      w = parseFloat(w);
    }
    let wght = w || 1;
    return new CriterionItem(this, c, `ci${this._ciCounter++}`, rg, wght);
  }

  clearCriterionItemValues() {
    this._tempCriterionItemValues.clear();
  }

  clearRecordCache(dbRecord: DbRecord) {
    this.rts.currentProject.criterionsMap.forEach((x) => {
      x.run(dbRecord, true);
    });
  }

  get(id: string) {
    return this.rts.currentProject.criterionsMap.get(id);
  }

  get criterionItemValues() {
    return this._tempCriterionItemValues;
  }

  initCIvalues(ci: CriterionItem, rg: string, w: string) {
    this._tempCriterionItemValues.set(ci.id, [rg, w]);
  }

  setCIregexp(ci: CriterionItem, rg: string) {
    this._tempCriterionItemValues.get(ci.id)[0] = rg;
  }

  setCIweight(ci: CriterionItem, w: string) {
    this._tempCriterionItemValues.get(ci.id)[1] = w;
  }

  getCIregexp(ci: CriterionItem) {
    return this._tempCriterionItemValues.get(ci.id)[0];
  }

  getCIweight(ci: CriterionItem) {
    return this._tempCriterionItemValues.get(ci.id)[1];
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/criterion.service.ts